import React, { useEffect, useState } from 'react'

import { Grid, Chip, Typography } from '@material-ui/core'

const UserWelcome = (props) => {
    const [profile, setProfile] = useState({})
    const [loading, setLoading] = useState(false)

    const id_user = props.id_user
    const dispaly_name = props.dispaly_name

    /* useEffect(() => {
        setLoading(true)

        const getUserProfile = async () => {
            //const areas_list = await myarea_list()
            setProfile({});
        }
        getUserProfile()
        setLoading(false)
    }, []) */

    if( loading )
        return <LoaderSingleComponent width="100%" />

    /* if( !Object.keys(profile).length )
        return null */

    return <>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs="auto">
                <Typography component="div" variant="body1">
                    Benvenuto {dispaly_name} 
                </Typography>
            </Grid>
            <Grid item xs>
                <Chip label={"ANTUSR-"+id_user} size="small" />
            </Grid>
        </Grid>
    </>
}

export default UserWelcome